const DV7_ACCESS_COMPANY_IDS = [2101, 2774, 2565, 2300, 669, 1059, 1053, 3801];
const CUSTOM_DV7_ACCESS_COMPANY_IDS = [2300, 669, 1059, 1053, 3801];
const isProd = window.location.hostname === 'fleet.roscolive.com';
export const getDV7Access = (companyId) => !isProd || (isProd && DV7_ACCESS_COMPANY_IDS.includes(companyId));
export const getCustomDV7Access = (companyId) => isProd && CUSTOM_DV7_ACCESS_COMPANY_IDS.includes(companyId);